import { defineMessages } from 'react-intl';

export default defineMessages({
    pageTitle: {
        id: 'twia.gateway.views.dashboard.title',
        defaultMessage: 'Dashboard',
    },
    openQuotesTile: {
        id: 'twia.gateway.directives.GatewayDashboardDirective.gateway-dashboard.Open Quotes',
        defaultMessage: 'Open Quotes',
    },
    policyChangeTile: {
        id: 'twia.gateway.directives.GatewayDashboardDirective.gateway-dashboard.Open Policy Changes',
        defaultMessage: 'Open Policy Changes',
    },
    cancellationsTile: {
        id: 'twia.gateway.directives.GatewayDashboardDirective.gateway-dashboard.Cancellations',
        defaultMessage: 'Open Cancellations',
    },
    openRenewalsTile: {
        id: 'twia.gateway.directives.GatewayDashboardDirective.gateway-dashboard.Open Renewals',
        defaultMessage: 'Open Renewals',
    },
    upComingActivities: {
        id: 'twia.gateway.views.activities.Activities for the next 7 days',
        defaultMessage: 'Your Open Activities',
    },
});
